import mapMarkerIconFactory from "../../../../../common/components/map/marker/map-marker-icon.factory";
import MapMarker from "../../../../../common/components/map/types/map-marker";
import MapRoute from "../../../../../common/components/map/types/map-route";
import { SearchRoadRoutingResponseRouteGeometryCoordinate } from "../../../../../common/utils/search-road-route/search-road-routing.response";
import { OrderOptimizerCargoListingItemRoute } from "./types/order-optimizer-cargo-listing-item";

const createMapMarker = (
  address: OrderOptimizerCargoListingItemRoute,
  addressNum: number
) => {
  const signature = `${addressNum + 1}`;

  const markerIcon = mapMarkerIconFactory.createIcon({
    className: "map_marker standard",
    content: signature,
  });

  const newMapMarker: MapMarker = {
    coordinate: {
      latitude: address.lat,
      longitude: address.lon,
    },
    icon: markerIcon,
  };

  return newMapMarker;
};

const createMapMarkers = (
  addressSequence: OrderOptimizerCargoListingItemRoute[]
): MapMarker[] => {
  return addressSequence.map(createMapMarker);
};

const createMapRoute = (
  routesResponseGeometryCoordinates: SearchRoadRoutingResponseRouteGeometryCoordinate[],
  color: string
): MapRoute => {
  return {
    waypoints: routesResponseGeometryCoordinates.map((coordinate) => {
      return {
        latitude: coordinate[1],
        longitude: coordinate[0],
      };
    }),
    options: {
      color: color,
    },
  };
};

const orderOptimizerCargoListingRouteFactory = {
  createMapMarkers,
  createMapRoute,
};

export default orderOptimizerCargoListingRouteFactory;
